export default [
  { text: 'в собственности', value: 'owned' },
  { text: 'в аренде', value: 'rent' },
];
